import {
    SET_FINANCE_ACCOUNTS_LIST,
    DISPLAY_ACCOUNT_NAME_MODAL
} from './constants';

export const initialState = { 
    accountsList: null,
    showEditAccountModal: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_FINANCE_ACCOUNTS_LIST:
      return {
        ...state,
        accountsList: payload
      };
    case DISPLAY_ACCOUNT_NAME_MODAL:
      return {
        ...state,
        showEditAccountModal: payload || initialState.showEditAccountModal
      };
    default:
        return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/features/finance/accounts/reducer.js